import React, { useContext, useEffect } from "react";
import styles from "./styles.module.css";
import WarningMsg from "components/utils/WarningMsg/WarningMsg";
import { ContactSupportTeamWhatsapp } from "components/utils/ContactSupportTeam";
import ShopContext from "context/ShopContext";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import { ReactComponent as PrinterIcon } from "images/svg/printer_light_gray.svg";
import AppBridgeHelper from "helpers/AppBridgeHelper";
import { QRCodeSVG } from "qrcode.react";
import { QR_SERVER_IP_PREFIX } from "const";

function KOT() {
  const { hasFullKotValidity } = useContext(ShopContext);
  const [serverIp, setServerIp] = React.useState("Loading...");

  useEffect(() => {
    const fetchIp = async () => {
      const bridge = AppBridgeHelper.getBridge();
      if (!bridge) {
        setServerIp("Unknown");
        return;
      }
      const ip = await bridge.getLocalIp();
      setServerIp(ip);
    };
    fetchIp();
  }, []);

  return (
    <>
      {hasFullKotValidity ? (
        <div className={styles.container}>
          <div className={styles.serverContainer}>
            <div className={styles.serverInfo}>
              <PrinterIcon />
              <span className={styles.label}>Server IP :</span>
              <span className={styles.boldTxt}>{serverIp}</span>
            </div>

            <ButtonRed style={{ display: "none" }}>Stop Server</ButtonRed>
          </div>
          {serverIp && serverIp !== "Loading..." && serverIp !== "Unknown" && (
            <div className={styles.qrCodeContainer}>
              <QRCodeSVG value={`${QR_SERVER_IP_PREFIX}${serverIp}`} size={130} />
            </div>
          )}
        </div>
      ) : (
        <div className={styles.warningContainer}>
          <WarningMsg
            title="No Subscription"
            message={`You don't have a KOT subscription yet`}
            btnName="Contact Support"
            onClickHandler={ContactSupportTeamWhatsapp}
          />
        </div>
      )}
    </>
  );
}

export default KOT;
